import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3154f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex",
  style: { minHeight: '100vh' }
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pt-12 fs-4x text-w-green" }, "WESERVE GO", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "d-xl-flex d-none flex-column flex-grow-1 justify-content-center align-items-center",
      style: _normalizeStyle({
        backgroundImage:
          'url(' + 'media/illustrations/login/login-background.png' + ')',
      })
    }, [
      _createElementVNode("span", null, [
        _createVNode(_component_inline_svg, { src: "media/logos/login-logo.svg" })
      ]),
      _hoisted_2
    ], 4),
    _createVNode(_component_router_view)
  ]))
}